var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useCallback, useReducer } from 'react';
import { useDisclosure } from 'shared/components';
import { PowerPanelWrapper } from '../components';
import { PowerPanelContentContainer } from '../components/powerPanelContentContainer';
import { PowerPanelHeaderContainer } from '../components/powerPanelHeaderContainer';
export var PowerPanelContextActionTypes;
(function (PowerPanelContextActionTypes) {
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_HEADER"] = 0] = "SET_HEADER";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_HEADER_CONTAINER"] = 1] = "SET_HEADER_CONTAINER";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_CONTENT"] = 2] = "SET_CONTENT";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_CONTENT_CONTAINER"] = 3] = "SET_CONTENT_CONTAINER";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_FOOTER"] = 4] = "SET_FOOTER";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_DISMISS_ON_NAV"] = 5] = "SET_DISMISS_ON_NAV";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_PANEL_BOX_PROPS"] = 6] = "SET_PANEL_BOX_PROPS";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_ON_CLOSE"] = 7] = "SET_ON_CLOSE";
    PowerPanelContextActionTypes[PowerPanelContextActionTypes["SET_ACTIVE_ID"] = 8] = "SET_ACTIVE_ID";
})(PowerPanelContextActionTypes || (PowerPanelContextActionTypes = {}));
var initialState = {
    disclosure: { isOpen: false },
    header: '',
    headerContainer: PowerPanelHeaderContainer,
    content: null,
    contentContainer: PowerPanelContentContainer,
    footer: null,
    dismissOnNav: false,
    panelBoxProps: {},
    activeId: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: function () { },
};
export var powerPanelContext = createContext({
    state: initialState,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dispatch: function () { },
});
var PowerPanelProvider = function (_a) {
    var children = _a.children;
    var disclosure = useDisclosure();
    var _b = useReducer(function (state, action) {
        switch (action.type) {
            case PowerPanelContextActionTypes.SET_HEADER:
                return __assign(__assign({}, state), { header: action.payload });
            case PowerPanelContextActionTypes.SET_HEADER_CONTAINER:
                return __assign(__assign({}, state), { headerContainer: action.payload });
            case PowerPanelContextActionTypes.SET_CONTENT:
                return __assign(__assign({}, state), { content: action.payload });
            case PowerPanelContextActionTypes.SET_CONTENT_CONTAINER:
                return __assign(__assign({}, state), { contentContainer: action.payload });
            case PowerPanelContextActionTypes.SET_FOOTER:
                return __assign(__assign({}, state), { footer: action.payload });
            case PowerPanelContextActionTypes.SET_DISMISS_ON_NAV:
                return __assign(__assign({}, state), { dismissOnNav: action.payload });
            case PowerPanelContextActionTypes.SET_PANEL_BOX_PROPS:
                return __assign(__assign({}, state), { panelBoxProps: action.payload });
            case PowerPanelContextActionTypes.SET_ON_CLOSE:
                return __assign(__assign({}, state), { onClose: action.payload });
            case PowerPanelContextActionTypes.SET_ACTIVE_ID:
                return __assign(__assign({}, state), { activeId: action.payload });
            default:
                throw new Error('Invalid action');
        }
    }, initialState), state = _b[0], dispatch = _b[1];
    return (_jsx(powerPanelContext.Provider, __assign({ value: { state: __assign(__assign({}, state), { disclosure: disclosure }), dispatch: dispatch } }, { children: _jsx(PowerPanelWrapper, { children: children }) })));
};
var usePowerPanelContext = function () {
    var context = useContext(powerPanelContext);
    var dispatch = context.dispatch;
    if (context === undefined) {
        throw new Error('usePowerPanelContext must be used within a PowerPanelProvider');
    }
    var setPanelBoxProps = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_PANEL_BOX_PROPS, payload: payload });
    };
    var setHeader = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_HEADER, payload: payload });
    };
    var setHeaderContainer = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_HEADER_CONTAINER, payload: payload });
    };
    var setContent = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_CONTENT, payload: payload });
    };
    var setContentContainer = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_CONTENT_CONTAINER, payload: payload });
    };
    var setFooter = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_FOOTER, payload: payload });
    };
    var setDismissOnNav = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_DISMISS_ON_NAV, payload: payload });
    };
    var setOnClose = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_ON_CLOSE, payload: payload });
    };
    var setActiveId = function (payload) {
        dispatch({ type: PowerPanelContextActionTypes.SET_ACTIVE_ID, payload: payload });
    };
    var onClose = useCallback(function () {
        setActiveId(null);
        context.state.disclosure.onClose();
        context.state.onClose();
    }, [context.state.onClose, context.state.disclosure]);
    return __assign(__assign(__assign({}, context), context.state), { onClose: onClose, setPanelBoxProps: setPanelBoxProps, setHeader: setHeader, setHeaderContainer: setHeaderContainer, setContent: setContent, setContentContainer: setContentContainer, setFooter: setFooter, setDismissOnNav: setDismissOnNav, setOnClose: setOnClose, setActiveId: setActiveId });
};
export { PowerPanelProvider, usePowerPanelContext };
